export class Panel {
  nextElement() {
    let nextElement = this.currentElement?.nextElementSibling;
    if (!nextElement) {
      return;
    }

    this.setElement(nextElement);
  }

  previousElement() {
    const previousElement = this.currentElement?.previousElementSibling;
    if (!previousElement) {
      return;
    }

    this.setElement(previousElement);
  }

  setElement(element) {
    this.currentElement = element;
  }

  checkDetailsActions() {
    // On regarde si l'élément courant a un élément qui le précède et s'il en a un qui le suit
    document
      .querySelector(
        '.search-results-preview [data-action="search-result-details:next"]',
      )
      .toggleAttribute(
        'disabled',
        !this.currentElement?.nextElementSibling?.matches('.listing-element'),
      );

    document
      .querySelector(
        '.search-results-preview [data-action="search-result-details:previous"]',
      )
      .toggleAttribute(
        'disabled',
        !this.currentElement?.previousElementSibling?.matches(
          '.listing-element',
        ),
      );
  }
}
